export const metaIndividualFilterFields = [
  {
    name: "name",
    label: "Colaborador",
    type: "text" as const,
    placeholder: "Digite o nome do colaborador",
  },
  {
    name: "lojaId",
    label: "Loja",
    type: "select" as const,
    placeholder: "Selecione uma loja",
    options: [],
  },
  {
    name: "tipo",
    label: "Tipo de Meta",
    type: "select" as const,
    placeholder: "Selecione um tipo",
    options: [
      { value: "producao", label: "Produção" },
      { value: "entrega", label: "Entrega" },
    ],
  },
  {
    name: "dataInicio",
    label: "Data Início",
    type: "date" as const,
    placeholder: "Selecione a data de início",
  },
  {
    name: "dataFim",
    label: "Data Fim",
    type: "date" as const,
    placeholder: "Selecione a data de fim",
  },
];
